/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import MyAccount from '../MyAccount';
import MyAccountIcon from '../MyAccount/subcomponents/MyAccountIcon';
import HoverableSlideOutModal from '../HoverableSlideOutModal/HoverableSlideOutModal';

function DesktopMyAccountModal(props) {
  // eslint-disable-next-line react/prop-types
  const {
    myAccountIconProps, onMouseEnter, onMouseLeave, onLoginClose, removeScrollFreeze, ...otherProps
  } = props;
  if (window.FLAGS && window.FLAGS.CourtesyNav) {
    return (
      <HoverableSlideOutModal
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        {...otherProps}
        showModal
        hideOverlay={false}
        target={<MyAccountIcon {...myAccountIconProps} />}
        component={(
          <MyAccount
            onLoginClose={onLoginClose}
            removeScrollFreeze={removeScrollFreeze}
          />
)}
      />
    );
  }
  return (
    <HoverableSlideOutModal
      showModal={false}
      hideOverlay
      {...otherProps}
      target={<MyAccountIcon {...myAccountIconProps} />}
    />
  );
}

DesktopMyAccountModal.propTypes = {
  myAccountIconProps: PropTypes.shape({
    className: PropTypes.string,
    onMouseUp: PropTypes.func,
    onTouchEnd: PropTypes.func,
  }),
};

DesktopMyAccountModal.defaultProps = {
  myAccountIconProps: {
    className: null,
    onMouseUp: null,
    onTouchEnd: null,
  },
};

export default DesktopMyAccountModal;
